import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaArrowRight
} from "react-icons/fa";
import logo from "../assets/logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-premium">
      {/* Visual Accents */}
      <div className="footer-glow" />
      
      <Container className="footer-content">
        <Row className="gy-5">
          {/* Brand Engine */}
          <Col lg={4} md={12} className="footer-brand-stage">
            <Link to="/" className="brand-link">
              <img src={logo} alt="Sukkur IBA" className="footer-logo-main" />
              <div className="brand-text">
                <h2 className="title">SUKKUR IBA</h2>
                <p className="subtitle">UNIVERSITY</p>
              </div>
            </Link>
            <p className="brand-mission">
              Dedicated to excellence in education, research, and innovation. Shaping leaders for a global future since 1994.
            </p>
            <div className="footer-social-tray">
              <a href="https://facebook.com" className="social-pill"><FaFacebookF /></a>
              <a href="https://twitter.com" className="social-pill"><FaTwitter /></a>
              <a href="https://linkedin.com" className="social-pill"><FaLinkedinIn /></a>
              <a href="https://instagram.com" className="social-pill"><FaInstagram /></a>
              <a href="https://youtube.com" className="social-pill"><FaYoutube /></a>
            </div>
          </Col>

          {/* Quick Nav Space */}
          <Col lg={4} md={6} sm={12}>
            <div className="footer-nav-col">
              <h4 className="section-title">Quick Navigation</h4>
              <div className="link-grid">
                <Link to="/" className="nav-item-link">
                  <FaArrowRight className="link-icon" /> Home
                </Link>
                <Link to="/about" className="nav-item-link">
                  <FaArrowRight className="link-icon" /> About IBA
                </Link>
                <Link to="/admissions" className="nav-item-link">
                  <FaArrowRight className="link-icon" /> Admissions
                </Link>
                <Link to="/programs" className="nav-item-link">
                  <FaArrowRight className="link-icon" /> Programs
                </Link>
                <Link to="/contact" className="nav-item-link">
                  <FaArrowRight className="link-icon" /> Support
                </Link>
              </div>
            </div>
          </Col>

          {/* Contact Stage */}
          <Col lg={4} md={6} sm={12}>
            <div className="footer-nav-col">
              <h4 className="section-title">Contact Information</h4>
              <div className="contact-card-glass">
                <div className="contact-row">
                  <div className="icon-wrap"><FaMapMarkerAlt /></div>
                  <div className="text-wrap">
                    <p>Nisar Ahmed Siddiqui Road,</p>
                    <p className="sub">Sukkur, Sindh, Pakistan</p>
                  </div>
                </div>
                <div className="contact-row">
                  <div className="icon-wrap"><FaPhoneAlt /></div>
                  <div className="text-wrap">
                    <a href="tel:+92715644276">071-5644276</a>
                  </div>
                </div>
                <div className="contact-row">
                  <div className="icon-wrap"><FaEnvelope /></div>
                  <div className="text-wrap">
                    <a href="mailto:info@iba-suk.edu.pk">info@iba-suk.edu.pk</a>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Copy Stage */}
      <div className="footer-bottom-bar">
        <Container>
          <div className="bottom-flex">
            <p className="copy-text">
              © {currentYear} <strong>Sukkur IBA University</strong>. All Rights Reserved.
            </p>
            <div className="policy-links">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
            </div>
          </div>
        </Container>
      </div>

      <style>{`
        .footer-premium {
          --f-navy: #001e3c;
          --f-deep: #00152b;
          --f-cyan: #00ced1;
          --f-text: #94a3b8;
          --f-white: #ffffff;
          
          background: var(--f-deep);
          color: var(--f-white);
          padding: 80px 0 0;
          position: relative;
          overflow: hidden;
          font-family: 'Inter', sans-serif;
        }

        .footer-glow {
          position: absolute;
          top: -20%;
          left: 50%;
          transform: translateX(-50%);
          width: 800px;
          height: 400px;
          background: radial-gradient(circle, rgba(0, 206, 209, 0.05) 0%, transparent 70%);
          filter: blur(80px);
          pointer-events: none;
        }

        /* Brand Column */
        .brand-link {
          display: flex;
          align-items: center;
          gap: 15px;
          text-decoration: none;
          margin-bottom: 25px;
        }
        .footer-logo-main {
          height: 60px;
          width: auto;
          filter: drop-shadow(0 4px 10px rgba(0,0,0,0.3));
        }
        .brand-text .title {
          font-size: 1.4rem;
          font-weight: 900;
          margin: 0;
          color: var(--f-white);
          letter-spacing: -0.5px;
        }
        .brand-text .subtitle {
          font-size: 0.75rem;
          font-weight: 600;
          margin: 0;
          color: var(--f-cyan);
          letter-spacing: 2px;
          opacity: 0.9;
        }
        .brand-mission {
          font-size: 0.9rem;
          line-height: 1.7;
          color: var(--f-text);
          margin-bottom: 30px;
          max-width: 320px;
        }

        .footer-social-tray {
          display: flex;
          gap: 10px;
        }
        .social-pill {
          width: 38px;
          height: 38px;
          border-radius: 10px;
          background: rgba(255,255,255,0.03);
          border: 1px solid rgba(255,255,255,0.06);
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--f-text);
          text-decoration: none;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .social-pill:hover {
          background: var(--f-cyan);
          color: var(--f-navy);
          transform: translateY(-4px);
          box-shadow: 0 8px 20px rgba(0, 206, 209, 0.2);
        }

        /* Nav Columns */
        .section-title {
          font-size: 1.1rem;
          font-weight: 700;
          margin-bottom: 30px;
          position: relative;
          color: var(--f-white);
        }
        .section-title::after {
          content: '';
          position: absolute;
          bottom: -8px;
          left: 0;
          width: 30px;
          height: 2px;
          background: var(--f-cyan);
          border-radius: 2px;
        }

        .link-grid {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }
        .nav-item-link {
          color: var(--f-text);
          text-decoration: none;
          font-size: 0.95rem;
          display: flex;
          align-items: center;
          gap: 10px;
          transition: 0.2s;
        }
        .nav-item-link .link-icon {
          font-size: 0.7rem;
          color: var(--f-cyan);
          opacity: 0;
          transition: 0.3s;
          transform: translateX(-5px);
        }
        .nav-item-link:hover {
          color: var(--f-white);
          transform: translateX(5px);
        }
        .nav-item-link:hover .link-icon {
          opacity: 1;
          transform: translateX(0);
        }

        /* Contact Glass */
        .contact-card-glass {
          background: rgba(255,255,255,0.02);
          border: 1px solid rgba(255,255,255,0.05);
          border-radius: 20px;
          padding: 20px;
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        .contact-row {
          display: flex;
          align-items: flex-start;
          gap: 15px;
        }
        .contact-row .icon-wrap {
          margin-top: 3px;
          color: var(--f-cyan);
          font-size: 1rem;
        }
        .contact-row .text-wrap p { margin: 0; font-size: 0.9rem; color: var(--f-white); }
        .contact-row .text-wrap p.sub { font-size: 0.8rem; color: var(--f-text); }
        .contact-row .text-wrap a {
          color: var(--f-white);
          text-decoration: none;
          font-size: 0.9rem;
          font-weight: 600;
          transition: 0.2s;
        }
        .contact-row .text-wrap a:hover { color: var(--f-cyan); }

        /* Bottom Bar */
        .footer-bottom-bar {
          margin-top: 80px;
          padding: 30px 0;
          border-top: 1px solid rgba(255,255,255,0.04);
          background: rgba(0,0,0,0.2);
        }
        .bottom-flex {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 20px;
        }
        .copy-text {
          margin: 0;
          font-size: 0.85rem;
          color: var(--f-text);
        }
        .copy-text strong { color: rgba(255,255,255,0.7); }
        .policy-links {
          display: flex;
          gap: 25px;
        }
        .policy-links a {
          font-size: 0.85rem;
          color: var(--f-text);
          text-decoration: none;
          transition: 0.2s;
        }
        .policy-links a:hover { color: var(--f-cyan); }

        @media (max-width: 991px) {
          .footer-premium { padding: 50px 0 0; }
          .footer-brand-stage {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
          }
          .brand-mission { margin-bottom: 20px; font-size: 0.85rem; }
          .section-title { text-align: center; margin-bottom: 20px; }
          .section-title::after { left: 50%; transform: translateX(-50%); }
          .link-grid { align-items: center; gap: 10px; }
          .footer-bottom-bar { margin-top: 50px; }
          .bottom-flex { flex-direction: column; text-align: center; gap: 10px; }
        }

        @media (max-width: 576px) {
          .footer-premium { padding-top: 40px; }
          .contact-card-glass { padding: 12px; gap: 15px; }
          .footer-bottom-bar { margin-top: 40px; padding: 20px 0; }
          .policy-links { gap: 15px; flex-wrap: wrap; justify-content: center; }
          .nav-item-link { font-size: 0.85rem; }
          .brand-text .title { font-size: 1.2rem; }
          .footer-logo-main { height: 50px; }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
